module.exports = __webpack_public_path__ + "img/home_news_2.26b5d82b.png";